/* eslint-disable react/no-danger */
import { dangerousGettext, gettext } from '@eventbrite/i18n';
import React from 'react';
import { Helmet } from 'react-helmet';
import {
    getCompetitors,
    getPartnerData,
    showDisclaimer,
} from './CompetitorComparisionBlockUtils';

import './CompetitorTable.scss';

export const CompetitorComparisionBlock = () => {
    const partnerData = getPartnerData();
    const competitors = getCompetitors();
    return (
        <>
            <Helmet>
                <link
                    href="https://eventbrite-s3.s3.amazonaws.com/marketing/landingpages/assets/2023/components/competitors-table/css/normalize.css"
                    rel="stylesheet"
                    type="text/css"
                />
                <link
                    href="https://eventbrite-s3.s3.amazonaws.com/marketing/landingpages/assets/2023/components/competitors-table/css/webflow.css"
                    rel="stylesheet"
                    type="text/css"
                />
                <link
                    href="https://eventbrite-s3.s3.amazonaws.com/marketing/landingpages/assets/2023/components/competitors-table/css/components-f9ecc1.webflow.css"
                    rel="stylesheet"
                    type="text/css"
                />
                <script
                    src="https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=624dd57eb706f8761d7b9988"
                    type="text/javascript"
                    integrity="sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0="
                    crossOrigin="anonymous"
                ></script>
                <script
                    src="https://eventbrite-s3.s3.amazonaws.com/marketing/landingpages/assets/2023/components/competitors-table/js/webflow.js"
                    type="text/javascript"
                ></script>
            </Helmet>

            <section className="c-table-competitors__section is-white">
                <div className="w-layout-blockcontainer c-table-competitors__container w-container">
                    <div className="c-eb-intro__grid-container is-halloween">
                        <h3 className="c-competitors-intro__h3">
                            {' '}
                            {gettext('Partner with Eventbrite')}{' '}
                        </h3>
                        <div
                            data-current="Tab 0"
                            data-easing="ease"
                            data-duration-in="300"
                            data-duration-out="100"
                            className="c-tabs__mobile w-tabs"
                        >
                            <div className="w-tab-menu">
                                {Object.keys(partnerData).map(
                                    (category, id) => (
                                        <a
                                            key={`${category}-${id}`}
                                            data-w-tab={`Tab ${id}`}
                                            className="c-intro-grid-tabs__tab w-inline-block w-tab-link w--current"
                                        >
                                            <div className="div-block-23">
                                                <div
                                                    className="c-intro-grid-tabs__text"
                                                    dangerouslySetInnerHTML={{
                                                        __html: dangerousGettext(
                                                            category,
                                                        ).toString(),
                                                    }}
                                                ></div>
                                                <img
                                                    src="https://eventbrite-s3.s3.amazonaws.com/marketing/landingpages/assets/2023/components/competitors-table/images/a_anchor-tab.svg"
                                                    loading="lazy"
                                                    alt=""
                                                />
                                            </div>

                                            <div
                                                style={{
                                                    height: '100%',
                                                    opacity: 1,
                                                }}
                                                className="c-intro-grid--info"
                                            >
                                                {Object.entries(
                                                    partnerData[category],
                                                ).map(([companyName, data]) => (
                                                    <div
                                                        className="c-intro-grid__row"
                                                        key={`${category}-${companyName}`}
                                                    >
                                                        <div className="c-intro-grid-row__infocont">
                                                            <p className="paragraph">
                                                                {data.highlight ? (
                                                                    <strong className="bold-text">
                                                                        {
                                                                            companyName
                                                                        }
                                                                    </strong>
                                                                ) : (
                                                                    companyName
                                                                )}
                                                            </p>
                                                        </div>
                                                        <div className="c-intro-grid-row__infocont">
                                                            {data.value}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </a>
                                    ),
                                )}
                            </div>
                            <div className="tabs-content-2 w-tab-content">
                                <div
                                    data-w-tab="Tab 0"
                                    className="w-tab-pane w--tab-active"
                                ></div>
                                <div
                                    data-w-tab="Tab 1"
                                    className="w-tab-pane"
                                ></div>
                                <div
                                    data-w-tab="Tab 2"
                                    className="w-tab-pane"
                                ></div>
                                <div
                                    data-w-tab="Tab 3"
                                    className="w-tab-pane"
                                ></div>
                            </div>
                        </div>
                        <a
                            href="/creator/onboarding/onboarding-redirect"
                            className="c-competitor__button is--pill-button is-orange is-halloween only-mobile w-inline-block"
                        >
                            <div className="c-fyp--maincta__container">
                                <div className="c-cta-button__text">
                                    {' '}
                                    {gettext('Get started')}{' '}
                                </div>
                            </div>
                        </a>
                        <div className="c-grid__desktop is-white">
                            <div
                                id="w-node-eb6aae47-3298-e205-aefd-12143b9fa923-58f5aa74"
                                className="div-block-7"
                            ></div>

                            <p className="c-competitors-grid__text is-bold is-white">
                                {' '}
                                Eventbrite{' '}
                            </p>
                            {competitors.map((company) => (
                                <p
                                    className="c-competitors-grid__text"
                                    key={company}
                                >
                                    {company}
                                </p>
                            ))}

                            {Object.keys(partnerData).map((category) => (
                                <>
                                    <div
                                        id="w-node-eb6aae47-3298-e205-aefd-12143b9fa92e-58f5aa74"
                                        className="c-eb-grid__separator"
                                        style={{ alignSelf: 'baseline' }}
                                    >
                                        <p
                                            className="c-competitors-grid__text"
                                            style={{ alignSelf: 'baseline' }}
                                            dangerouslySetInnerHTML={{
                                                __html: dangerousGettext(
                                                    category,
                                                ).toString(),
                                            }}
                                        ></p>
                                    </div>

                                    {Object.values(partnerData[category]).map(
                                        (data, id) => (
                                            <div
                                                id="w-node-eb6aae47-3298-e205-aefd-12143b9fa933-58f5aa74"
                                                className="c-eb-grid__separator is-centered"
                                                key={`${category}-${id}`}
                                                style={{
                                                    height: '100%',
                                                }}
                                            >
                                                {data.value}
                                            </div>
                                        ),
                                    )}
                                </>
                            ))}

                            <div
                                id="w-node-eb6aae47-3298-e205-aefd-12143b9fa976-58f5aa74"
                                className="div-block-7"
                            ></div>
                            <a
                                href="/creator/onboarding/onboarding-redirect"
                                className="c-competitor__button is--pill-button is-orange is-halloween w-inline-block"
                            >
                                <div className="c-fyp--maincta__container">
                                    <div className="c-cta-button__text">
                                        {' '}
                                        {gettext('Get started')}{' '}
                                    </div>
                                </div>
                            </a>
                        </div>
                        {showDisclaimer() && (
                            <div
                                className="c-eb-table__footnote-container"
                                style={{ marginTop: '24px' }}
                            >
                                <p
                                    className="c-eb__paragraph is-footnote"
                                    style={{
                                        textAlign: 'left',
                                        paddingBottom: '56px',
                                    }}
                                >
                                    {' '}
                                    {gettext(
                                        '1. Number of unique ticket buyers on Eventbrite in FY23; Other platforms scaled using Similarweb’s global web and mobile traffic and internal assumptions of traffic to ticket buyers ratio',
                                    )}{' '}
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};
